import React from "react";

import { MTLBenefitModal } from "../components/modals/MTLBenefitModal";
import CallInsuranceConsentRequestModal from "../components/modals/CallInsuranceConsentRequestModal";
import CallAssignedToTytoModal from "../components/modals/CallAssignedToTytoModal";

import AcsIframe from "../components/AcsIframe";
import WaitingCall from "../components/WaitingCall";

import { useCallLogic } from "../hooks/useCallLogic";

import { useTranslation } from "react-i18next";

export default function Call() {
  const {
    showLogo,
    isWaitingOverlayActive,
    logo,
    loading,
    recipientImage,
    recipientName,
    recipientSpecialty,
    transactionStatus,
    isCancelDisabled,
    acsJoinUrl,
    isAcsIframeActive,
    isMTLBenefitModalOpened,
    setIsMTLBenefitModalOpened,
    handleCancelCallConfirm,
    isConsentModalOpened,
    consentModalClosed,
    tytoModalClosed,
    isTytoModalOpened,
  } = useCallLogic();

  const { i18n } = useTranslation();

  return (
    <div className="flex flex-col items-center p-4 md:p-10 gap-y-4 justify-center min-h-screen w-full">
      <div className="flex flex-col items-center p-0 md:p-10 gap-y-4 w-full">
        {/* {logo && <img src={logo} alt="logo" className="w-40 h-16" />} */}
        {isMTLBenefitModalOpened && (
          <MTLBenefitModal onClose={() => setIsMTLBenefitModalOpened(false)} />
        )}
        {isTytoModalOpened && (
          <CallAssignedToTytoModal locale="th" onClose={tytoModalClosed} />
        )}
        {isConsentModalOpened && (
          <CallInsuranceConsentRequestModal
            locale={i18n.language === "th" ? "th" : "en"}
            onClose={consentModalClosed}
          />
        )}
        <div className={isWaitingOverlayActive ? "waiting-overlay w-full flex items-center justify-center min-h-screen p-4 md:p-10" : "w-full"}>
          <WaitingCall
            showLogo={showLogo}
            logo={logo}
            loading={loading}
            recipientImage={recipientImage}
            recipientName={recipientName}
            recipientSpecialty={recipientSpecialty}
            transactionStatus={transactionStatus}
            isCancelDisabled={isCancelDisabled}
            handleCancelCallConfirm={handleCancelCallConfirm}
            isTytoModalOpened={isTytoModalOpened}
            isConsentModalOpened={isConsentModalOpened}
            isMTLBenefitModalOpened={isMTLBenefitModalOpened}
          />
        </div>

        {acsJoinUrl && <AcsIframe url={acsJoinUrl} isActive={isAcsIframeActive} />}
      </div>
    </div>
  );
}
